import { useTranslate } from 'ra-core';
import { authProvider } from '@/authProvider.ts';
import { useQuery } from '@tanstack/react-query';
import { Loading } from '@/components/admin';
import { ArrowRight, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button.tsx';
import { Link } from 'react-router-dom';

type Props = {
  oobCode: string;
};

function EmailVerificationPage({ oobCode }: Props) {
  const t = useTranslate();
  const { isLoading: isVerifying, isSuccess: isEmailVerified } = useQuery({
    queryKey: ['verify-email', { oobCode }],
    queryFn: () => {
      return authProvider.verifyEmail(oobCode);
    },
  });

  if (isVerifying) {
    return (
      <>
        <img
          alt="logo"
          src="https://storage.googleapis.com/public-goloot-production/goloot/goloot-logo-black.png"
          style={{ height: 55 }}
        />
        {isVerifying && <Loading />}
      </>
    );
  }

  return (
    <div className="flex min-h-screen flex-col items-center justify-center p-4">
      <img
        alt="logo"
        src="https://storage.googleapis.com/public-goloot-production/goloot/goloot-logo-black.png"
        className="mb-8 h-[55px]"
      />

      {isVerifying && (
        <Loader2 className="h-12 w-12 animate-spin text-primary" />
      )}

      {!isVerifying && isEmailVerified && (
        <div className="text-center">
          <h2 className="mb-8 text-2xl font-semibold tracking-tight">
            {t('auth.message.verified')}
          </h2>
          <Button asChild size="lg">
            <Link to="/login">
              {t('auth.button.login')}
              <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
          </Button>
        </div>
      )}

      {!isVerifying && !isEmailVerified && (
        <p className="text-lg text-destructive">{t('error.oops')}</p>
      )}
    </div>
  );
}

export default EmailVerificationPage;
